import React, { useRef, useState } from 'react'
// import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify'

import Movieimagepresignedurl from '../../Services/Queries/Movieimagepresignedurl'
// import ImportMovie from '../../Services/Mutations/ImportMovie'
import 'react-toastify/dist/ReactToastify.css'
import AwsConfig from '../../Config/AwsConfig'

const toastStyle = {
  position: 'top-right',
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

const ImportPersonExtendedInfo = () => {
  const { extendedInfoUrl } = AwsConfig
  const fileInputRef = useRef()
  const [selectedFile, setSelectedFile] = useState(null)
  const [responselog, setresponselog] = useState([])

  const handleFileChange = event => {
    setSelectedFile(event.target.files[0])
  }

  const resetForm = () => {
    setSelectedFile(null)
    fileInputRef.current.value = ''
  }

  const getPresignedUrl = async params => {
    try {
      const preSignedURLObject = await Movieimagepresignedurl(params)
      return JSON.parse(preSignedURLObject.signedObject)
    } catch (error) {
      console.error('Error fetching presigned URL:', error)
      toast.error('Error fetching presigned URL', toastStyle)
      throw error
    }
  }

  const uploadFileToS3 = async (signedURLObject, file) => {
    try {
      const formData = new FormData()
      Object.entries(signedURLObject.data.fields).forEach(([key, value]) => {
        formData.append(key, value)
      })
      formData.append('file', file)

      await axios({
        method: 'post',
        url: signedURLObject.data.url,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    } catch (error) {
      console.error('Error uploading file to S3:', error)
      toast.error('File upload failed', toastStyle)
      throw error
    }
  }

  const importMovieData = async importInput => {
    try {
      //   const importDataResponse = await ImportMovie(importInput)
      //   if (importDataResponse.statusCode === 'A009') {
      // toast.success(importDataResponse.statusMessage, toastStyle)
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: extendedInfoUrl,
        headers: {
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(importInput),
      }

      axios
        .request(config)
        .then(response => {
          console.log(response, 'response===')
          //   SetGptValue(response.data.data)
          //   setIsLoading(false)
          setresponselog(response.data)
          if (response.data && response.data.length === 0) {
            toast.sucess('Import Successful', toastStyle)
          }
        })
        .catch(error => {
          toast.error(error, toastStyle)
        })
      console.log(importInput, 'importInput===')
      resetForm()
      //   } else {
      // toast.error(importDataResponse.statusMessage, toastStyle)
      //   }
    } catch (error) {
      console.error('Error importing movie data:', error)
      toast.error('Error importing movie data', toastStyle)
      throw error
    }
  }

  const handleUploadFile = async () => {
    try {
      if (!selectedFile) {
        toast.error('No file selected', toastStyle)
        return
      }

      // const randomId = uuidv4()
      const key = `public/importData/persons/${selectedFile.name}`
      const params = { key, mimeType: selectedFile.type }

      try {
        const signedURLObject = await getPresignedUrl(params)
        await uploadFileToS3(signedURLObject, selectedFile)

        const importInput = { path: key }
        await importMovieData(importInput)
      } catch (error) {
        console.error('Upload process failed:', error)
      }
    } catch (error) {
      console.error('Unexpected error during upload:', error)
      toast.error('Unexpected error during upload', toastStyle)
    }
  }

  return (
    <>
      <h4 className='mt-2'>Import Persons ExtendedInfo</h4>
      <ToastContainer />
      <div className='mb-3 mt-3 w-50'>
        <label htmlFor='formFile' className='form-label'>
          Choose File
        </label>
        <input
          ref={fileInputRef}
          onChange={handleFileChange}
          className='form-control'
          accept='.xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
          type='file'
          id='formFile'
        />
      </div>
      <button
        type='button'
        className='btn btn-primary'
        disabled={!selectedFile}
        onClick={handleUploadFile}
      >
        Upload
      </button>
      <div style={{ padding: '20px' }}>
      {responselog && responselog.map((issue, index) => (
        <div key={index} >
          {issue.split('-->').map((line, idx) => (
            <div key={idx} >{line.trim()}</div>
          ))}
        </div>
      ))}
    </div>
    </>
  )
}

export default ImportPersonExtendedInfo
